import React, { useState } from 'react';
import SeismicDesignSupport from './SeismicDesignSupport';
import SeismicAnalysis from './SeismicAnalysis';

/**
 * 내진설계지원 Container
 * STEP 1 (시추공 선택)과 STEP 2 (분석)를 관리하는 컨테이너
 */
function SeismicDesignSupportContainer({ showToast }) {
  const [step, setStep] = useState(1); // 1: 선택, 2: 분석
  const [selectedBoreholes, setSelectedBoreholes] = useState([]);

  const handleNext = (boreholes) => {
    setSelectedBoreholes(boreholes);
    setStep(2);
  };

  const handleBack = () => {
    setStep(1);
  };

  if (step === 1) {
    return <SeismicDesignSupport onNext={handleNext} />;
  }

  return (
    <SeismicAnalysis
      selectedBoreholes={selectedBoreholes}
      onBack={handleBack}
      showToast={showToast}
    />
  );
}

export default SeismicDesignSupportContainer;
